import { ROUTER_PATH } from "@/src/config/router";

const readString = (value: unknown): string | undefined =>
  typeof value === "string" ? value : undefined;

const isCryptoAssetType = (attrs: Record<string, unknown>): boolean => {
  const raw = attrs.assetType ?? attrs.asset_type;
  const s = readString(raw)?.toLowerCase();
  return s === "crypto";
};

/**
 * Builds href for notification `view_detail`: `/base/{symbol}[/{tab}]` — `tab` is passed through
 * from the backend. Each dynamic path segment is encoded separately (never encode the full path:
 * that would turn `/` into `%2F` and break routing).
 */
export function buildViewDetailHref(
  attrs: Record<string, unknown>,
): string | null {
  const legacyLink = readString(attrs.link);
  const symbol = readString(attrs.symbol);
  const tab = readString(attrs.tab);
  const cryptoId = readString(attrs.assetRouteId);

  if (symbol) {
    const encSymbol = encodeURIComponent(symbol);
    const normalizedTab = tab?.toLowerCase() === "score" ? "edgen-ai" : tab;
    const encCryptoId = cryptoId ? encodeURIComponent(cryptoId) : "";
    const encTab = normalizedTab ? encodeURIComponent(normalizedTab) : "";
    const tail = encTab ? `/${encTab}` : "";
    if (isCryptoAssetType(attrs)) {
      return `${ROUTER_PATH.CRYPTO_TOKEN}/${encCryptoId}${tail}`;
    }
    return `${ROUTER_PATH.STOCK_DETAIL}/${encSymbol}${tail}`;
  }

  if (legacyLink) {
    return `${ROUTER_PATH.STOCK_DETAIL}/${encodeURIComponent(legacyLink)}`;
  }
  return null;
}
